module.exports = __webpack_public_path__ + "514e8c86e9e2ce5ca36c3eb4ed0918ea.svg";